import * as React from 'react';
import { cn } from '@/lib/utils';
import './shimmer-button.css';

/**
 * Magic UI — Shimmer Button
 * https://magicui.design/docs/components/shimmer-button
 *
 * Ported to a dedicated stylesheet so the deeply-nested conic-gradient
 * shimmer renders reliably under CRA + Tailwind's class extractor.
 */
const ShimmerButton = React.forwardRef(
  (
    {
      shimmerColor = '#ffffff',
      shimmerSize = '0.05em',
      shimmerDuration = '3s',
      borderRadius = '100px',
      background = 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        style={{
          '--shimmer-color': shimmerColor,
          '--radius': borderRadius,
          '--speed': shimmerDuration,
          '--cut': shimmerSize,
          '--bg': background,
        }}
        className={cn('magic-shimmer-button', className)}
        ref={ref}
        {...props}
      >
        <div className="shimmer-spark-container">
          <div className="shimmer-slide">
            <div className="shimmer-spin" />
          </div>
        </div>
        {children}
        <div className="shimmer-highlight" />
        <div className="shimmer-backdrop" />
      </button>
    );
  }
);
ShimmerButton.displayName = 'ShimmerButton';

export { ShimmerButton };
